exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-nav[data-v-27eb766a]{background:#304156;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding-left:30px}.top-nav .tab-box[data-v-27eb766a]{width:120px;background:#768089;border-radius:10px 10px 0px 0px;text-align:center;margin-top:24px;padding:18px;font-size:14px;color:#fff;cursor:pointer;margin-right:10px}.top-nav .tab-box-active[data-v-27eb766a]{background:#fff;color:#282828}", ""]);

// exports
